import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <p>@ 2020 covid19 Tracker Apps- all  rights reserved - </p>

      <p>Privacy Lawalalao</p>
    </div>
  );
}

export default Footer;
